import { Pipe, PipeTransform } from '@angular/core';

import { PipeFunctions } from './_pipe.functions';

@Pipe({
    name: 'pickCustomer',
    standalone: false
})
export class CustomerPickerPipe implements PipeTransform {

    transform(raw: string): string {
        return PipeFunctions.pickCustomer(raw);
    }

}
